import React from 'react';
import Icon from '../../../../components/AppIcon';
import { SCENARIO_COLORS } from './analysisMetrics';
import { resolveMetricValue, formatMetricValue } from './analysisMetrics';
import { computeDelta, formatDelta, getDeltaToneClasses } from './analysisCompareUtils';

const ScenarioCompareTable = ({
  metrics = [],
  rowA,
  rowB,
  bundleA,
  bundleB,
  ctxA,
  ctxB,
  labelA,
  labelB,
  formatCurrency,
}) => {
  if (!metrics.length) return null;

  return (
    <div className="overflow-x-auto rounded-xl border border-border" data-testid="scenario-compare-table">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="bg-muted/30 text-left border-b border-border">
            <th className="py-2.5 px-3 font-medium text-muted-foreground">Indicateur</th>
            <th className="py-2.5 px-3 text-right font-medium" style={{ color: SCENARIO_COLORS.A }}>
              <span className="inline-flex items-center gap-1.5 justify-end">
                <span className="w-2 h-2 rounded-full shrink-0" style={{ background: SCENARIO_COLORS.A }} />
                {labelA}
              </span>
            </th>
            <th className="py-2.5 px-3 text-right font-medium" style={{ color: SCENARIO_COLORS.B }}>
              <span className="inline-flex items-center gap-1.5 justify-end">
                <span className="w-2 h-2 rounded-full shrink-0" style={{ background: SCENARIO_COLORS.B }} />
                {labelB}
              </span>
            </th>
            <th className="py-2.5 px-3 text-right font-medium text-muted-foreground">Écart (B − A)</th>
            <th className="py-2.5 px-3 text-right font-medium text-muted-foreground">Écart %</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {metrics.map((metric) => {
            const valA = resolveMetricValue(metric, rowA, bundleA, ctxA);
            const valB = resolveMetricValue(metric, rowB, bundleB, ctxB);
            const { delta, deltaPct, tone } = computeDelta(valA, valB, metric.higherIsBetter);
            const toneCls = getDeltaToneClasses(tone);
            const arrow = delta > 0 ? 'TrendingUp' : delta < 0 ? 'TrendingDown' : 'Minus';

            return (
              <tr key={metric.id} className="hover:bg-muted/20 transition-colors">
                <td className="py-2 px-3 text-foreground font-medium">{metric.label}</td>
                <td className="py-2 px-3 text-right tabular-nums" style={{ fontFamily: 'var(--font-data)' }}>
                  {formatMetricValue(valA, metric.format, formatCurrency)}
                </td>
                <td className="py-2 px-3 text-right tabular-nums" style={{ fontFamily: 'var(--font-data)' }}>
                  {formatMetricValue(valB, metric.format, formatCurrency)}
                </td>
                <td className={`py-2 px-3 text-right tabular-nums font-semibold ${toneCls.text} ${toneCls.bg}`} style={{ fontFamily: 'var(--font-data)' }}>
                  <span className="inline-flex items-center gap-1 justify-end">
                    {tone !== 'neutral' && <Icon name={arrow} size={14} />}
                    {formatDelta(delta, null, metric.format, formatCurrency).split(' (')[0]}
                  </span>
                </td>
                <td className={`py-2 px-3 text-right tabular-nums ${toneCls.text}`} style={{ fontFamily: 'var(--font-data)' }}>
                  {deltaPct != null ? `${deltaPct > 0 ? '+' : ''}${deltaPct.toFixed(1)}%` : '—'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};


export default ScenarioCompareTable;


